import React from 'react';
import { ORIENT_LABELS } from '../receptionConstants';
import { formatVisitDate } from '../receptionFormatters';
import { ReceptionStatusBadge } from '../ui';

const LINE_CLASS = {
  MEDICAL: 'recv-service-line--medical',
  DENTAL: 'recv-service-line--dental',
  NURSING: 'recv-service-line--nursing'
};

export default function OrientedConsultationsListRows({ rows }) {
  return rows.map((r) => {
    const patientName = r.patient_display || '—';
    const patientMeta = [r.member_matricule, r.company_name].filter(Boolean).join(' · ');
    const lineKey = String(r.service_line || '').toUpperCase();
    const assignation = r.doctor_id
      ? (r.assigned_doctor_name || '').trim() || `ID ${r.doctor_id}`
      : 'File d’attente site';

    return (
      <article key={r.consultation_id} className="recv-dash-consult-row" role="listitem">
        <div className="recv-dash-consult-list__cell recv-dash-consult-list__cell--patient">
          <span className="recv-dash-consult-row__time">{formatVisitDate(r.consultation_created_at)}</span>
          <div className="recv-dash-consult-row__name" title={patientName}>
            {patientName}
          </div>
          {patientMeta ? (
            <div className="recv-dash-consult-row__meta" title={patientMeta}>
              {patientMeta}
            </div>
          ) : null}
        </div>
        <div className="recv-dash-consult-list__cell recv-dash-consult-list__cell--care">
          <span className="recv-dash-consult-row__label">Soins</span>
          <div className="recv-dash-consult-row__care">
            {r.service_line ? (
              <span
                className={`recv-service-line recv-service-line--compact ${LINE_CLASS[lineKey] || 'recv-service-line--medical'}`}
              >
                {ORIENT_LABELS[r.service_line] || r.service_line}
              </span>
            ) : (
              '—'
            )}
            {r.consultation_status ? (
              <ReceptionStatusBadge kind="consultation" value={r.consultation_status} />
            ) : null}
          </div>
        </div>
        <div className="recv-dash-consult-list__cell recv-dash-consult-list__cell--dossier">
          <span className="recv-dash-consult-row__label">Dossier</span>
          <div className="recv-dash-consult-row__dossier">
            <span className="recv-queue-consult__id font-monospace">#{r.consultation_id}</span>
            <span className="recv-dash-consult-row__assign" title={assignation}>
              {assignation}
            </span>
          </div>
        </div>
      </article>
    );
  });
}
